import { createAction, props } from '@ngrx/store';

export const updateSavedInStore = createAction(
	'[StateBookmark] Update Saved In Store',
	props<{ saved: boolean; uniId: number }>(),
);
